import { Component, inject } from '@angular/core';
import { IconsService } from '../../../services/icons.service';
import { limitScroll } from '../../../utils/generales';

@Component({
    selector: 'app-ir-arriba',
    imports: [],
    templateUrl: './ir-arriba.component.html',
    styleUrl: './ir-arriba.component.css'
})
export class IrArribaComponent {

    public _icon = inject(IconsService);

    public btnScrollup() {
        limitScroll(0);
    }

}
